import React from "react";
import "./Home.css";
import { Link } from "react-router-dom";
import Product from "./Product";
import Flightbot from "./Flightbot";
import flight from "./flight.mp4";
import home from "./home.png";

function Home() {
  return (
    <div className="home">
      <div className="home__container">
        <img className="home__image" src={home} alt="" />
        <div className="home__row">
          <Product
            id="12321341"
            title="Luigi's Mansion 3"
            title2="Luigi’s dream vacation turns into a ghostly - and gooey - nightmare!"
            description="Luigi embarks on a dream vacation with Mario and friends upon receiving an invitation to a luxurious hotel. However, his dream quickly becomes a nightmare when King Boo reveals everything had been a ploy to capture Mario and friends. With the assistance of Professor E. Gadd once again, the reluctant and cowardly hero Luigi traverses up and down treacherous doors of the now-ominous hotel on a quest to save them. Wield the upgraded Poltergust G-00 to slam and blow away the ghosts’ defences, or summon Gooigi, an all-green doppelganger that can help Luigi overcome obstacles he can’t get past alone. Interchange between Luigi and Gooigi as one player, or grab a friend and control one each. For more frenetic multiplayer action, race the timer to clear various objectives on a series of doors in ScareScraper mode. ScareScraper mode can be played online* or locally with up to eight players on four Nintendo Switch systems (additional games required; sold separately)."
            price={99.99}
            rating={5}
            image="https://c1-ebgames.eb-cdn.com.au/merchandising/images/packshots/f7136f0c2d9140829d41262db1558000_Large.jpg"
          />
          <Product
            id="49538094"
            title="Pokemon Sword & Pokemon Shield Expansion Pass (Game Add-On)"
            title2="The wild adventure continues!"
            description="Your adventure continues with the Pokémon Sword & Pokémon Shield Expansion Pass, containing new stories to experience, new Pokémon to encounter, and new Wild Areas to explore. You’ll even meet new and returning Legendary Pokémon along the way! The Expansion Pass contains two expansions, The Isle of Armor and The Crown Tundra."
            price={49.5}
            rating={4}
            image="https://c1-ebgames.eb-cdn.com.au/merchandising/images/packshots/6f9c12205a7446a7991a842c8ae90145_Large.jpg"
          />
        </div>

        <div className="home__row">
          <Product
            id="4903850"
            title="Ori and the Will of the Wisps"
            title2="Discover Ori's true destiny..."
            description="The little spirit Ori is no stranger to peril, but when a fateful flight puts the owlet Ku in harm’s way, it will take more than bravery to bring a family back together, heal a broken land, and discover Ori’s true destiny. This highly anticipated sequel to the acclaimed action platformer Ori and the Blind Forest finally comes to Nintendo Switch. Embark on an epic adventure in a vast world filled with new friends and foes that come to life in stunning, hand painted artwork. Set to a fully orchestrated original score, Ori and the Will of the Wisps continues the Moon Studios tradition of tightly crafted platforming action and deeply emotional storytelling."
            price={49.99}
            rating={3}
            image="https://c1-ebgames.eb-cdn.com.au/merchandising/images/packshots/0fff8c15dc234e15b74d1e592e94f07d_Large.jpg"
          />
          <Product
            id="23445930"
            title="Crash Bandicoot 4"
            title2="It's About Time - for a brand-wumping new Crash Bandicoot game!"
            description="Crash forward into a time shattered adventure with your favourite marsupials.
            Neo Cortex and N. Tropy are back at it again and launching an all-out assault on not just this universe, but the entire multiverse! Crash and Coco are here to save the day by reuniting the four Quantum Masks and bending the rules of reality.
            New abilities? Check. More playable characters? Yep. Alternate dimensions? Obviously. Ridonkulous bosses? For sure. Same awesome sauce? You bet."
            price={79.99}
            rating={5}
            image="https://c1-ebgames.eb-cdn.com.au/merchandising/images/packshots/12038bcf9d9b463e9ae4a1d84fbb4e19_Large.png"
          />
          <Product
            id="90829332"
            title="Nintendo Switch Fortnite Special Edition Console"
            title2="Product Descriptions"
            description="Nintendo Switch Console Contains: Nintendo Switch Console, Nintendo Switch Dock, Left and Right Joy-Con Controlle, Joy-Con Grip, Joy-Con Straps, Nintendo Switch AC Adapter, HDMI Cable"
            price={549.0}
            rating={4}
            image="https://c1-ebgames.eb-cdn.com.au/merchandising/images/packshots/adbacbece5ae446c8b7a4966656d4d26_Large.jpg"
          />
        </div>

        <div className="home__row">
          <Product
            id="90829332"
            title="Star Wars - Death Star Gunner, Officer & Trooper Pop! Vinyl Figure 3-Pack"
            title2="We count 30 Rebel ships, Lord Vader"
            description="Straight from a galaxy far, far away comes Funko's evil new Death Star Gunner, Officer & Trooper Pop! Vinyl Figure 3-Pack! Featuring 3 classic characters from Star Wars Episode IV: A New Hope:
            1. Imperial Gunners were members of the Imperial Navy's Starfighter Corps who manned the various weapons and engine rooms of the Empire's capital ships, military bases, and both Death Stars.
            2. Imperial Officers held a position of authority and responsibility in the military forces of the Empire, much like the legendary Grand Moff Tarkin.
            3. Death Star troopers were elite Imperial Navy troopers chosen by Grand Moff Tarkin for placement on the first Death Star."
            price={37.0}
            rating={4}
            image="https://c1-ebgames.eb-cdn.com.au/merchandising/images/packshots/0374c12ae0b14452ba21292c2c357ee2_Large.png"
          />
        </div>
        <div className="home__footer">
          <br></br>
          <br></br>
          Refund Policy | Shipping Policy | Privacy Policy
          <br></br>
          <br></br>
          <br></br>© 2021 Floof Game Store • Created with React JS and Firebase
          <br></br>
        </div>
      </div>
    </div>
  );
}

export default Home;
